/* ============================================================
   Buono Joyas — Comportamientos compartidos del front
   ------------------------------------------------------------
   - Animacion de aparicion al hacer scroll (.buono-reveal)
   - Calcula --header-height (no usamos <header-component> de Horizon)
   - Abre el carrito / la busqueda reales de Horizon
   - Rotacion de la barra de anuncios
   - Menu movil (drawer)
   Carga global con `defer`. Idempotente para el editor de temas.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Aparicion al hacer scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll('.buono-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Altura del header como variable CSS ---- */
  function setHeaderHeight() {
    var header = document.querySelector('.buono-header');
    if (header) {
      document.body.style.setProperty('--header-height', header.offsetHeight + 'px');
    }
  }

  /* ---- Abrir carrito / busqueda reales de Horizon ---- */
  window.buonoOpenCart = function () {
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.toggle === 'function') { drawer.toggle(); return; }
    window.location.href = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
  };

  window.buonoOpenSearch = function () {
    var modal = document.getElementById('search-modal');
    if (modal && typeof modal.showDialog === 'function') { modal.showDialog(); return; }
    if (modal && typeof modal.showModal === 'function') { modal.showModal(); return; }
    var dialog = modal && modal.querySelector('dialog');
    if (dialog && typeof dialog.showModal === 'function') { dialog.showModal(); return; }
    window.location.href = (window.Theme && window.Theme.routes && window.Theme.routes.search_url) || '/search';
  };

  /* ---- Barra de anuncios rotativa ---- */
  function initAnnounce() {
    document.querySelectorAll('[data-buono-announce]').forEach(function (bar) {
      if (bar.dataset.buonoReady) return;
      bar.dataset.buonoReady = '1';
      var items = bar.querySelectorAll('.buono-announce__item');
      if (items.length < 2) return;
      var speed = parseInt(bar.getAttribute('data-speed'), 10) || 3800;
      var i = 0;
      bar._buonoTimer = setInterval(function () {
        items[i].classList.remove('is-on');
        items[i].classList.add('is-out');
        var prev = i;
        i = (i + 1) % items.length;
        setTimeout(function () { items[prev].classList.remove('is-out'); }, 700);
        items[i].classList.add('is-on');
      }, speed);
    });
  }

  /* ---- Menu movil ---- */
  function initMobileMenu() {
    var menu = document.getElementById('buono-mmenu');
    if (!menu || menu.dataset.buonoReady) return;
    menu.dataset.buonoReady = '1';
    var overlay = document.getElementById('buono-overlay');

    function open() {
      menu.classList.add('is-on');
      if (overlay) overlay.classList.add('is-on');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      menu.classList.remove('is-on');
      if (overlay) overlay.classList.remove('is-on');
      document.documentElement.style.overflow = '';
    }

    document.querySelectorAll('[data-buono-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    document.querySelectorAll('[data-buono-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-on')) close();
    });
  }

  /* ---- Lista de deseos (localStorage) ---- */
  function initWishlist() {
    var KEY = 'buono_wish';
    var liked;
    try { liked = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { liked = []; }
    document.querySelectorAll('[data-buono-wish]').forEach(function (btn) {
      var id = btn.getAttribute('data-buono-wish');
      if (liked.indexOf(id) !== -1) btn.classList.add('is-liked');
      if (btn.dataset.buonoReady) return;
      btn.dataset.buonoReady = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var i = liked.indexOf(id);
        if (i === -1) { liked.push(id); btn.classList.add('is-liked'); }
        else { liked.splice(i, 1); btn.classList.remove('is-liked'); }
        try { localStorage.setItem(KEY, JSON.stringify(liked)); } catch (e2) {}
      });
    });
  }

  function init() {
    initReveal();
    setHeaderHeight();
    initAnnounce();
    initMobileMenu();
    initWishlist();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', setHeaderHeight);

  /* Acordeones (delegado global): descripción del PDP, FAQ, etc. */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-buono-acc-q]');
    if (!q) return;
    var item = q.closest('[data-buono-acc-item]');
    if (item) item.classList.toggle('is-open');
  });

  /* Enlaces a WhatsApp (footer, etc.): reutilizan el botón flotante configurado */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-buono-wa]');
    if (!link) return;
    var floating = document.querySelector('.buono-wa');
    if (floating && floating.href) {
      e.preventDefault();
      window.open(floating.href, '_blank', 'noopener');
    }
  });

  /* Re-inicializa al recargar secciones en el editor de temas */
  document.addEventListener('shopify:section:load', init);

  /* Limpia timers de la barra de anuncios al quitar/recargar secciones en el editor */
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-buono-announce]').forEach(function (bar) {
      if (bar._buonoTimer) { clearInterval(bar._buonoTimer); bar._buonoTimer = null; }
    });
  });
})();
